module.exports = __webpack_public_path__ + "static/img/banner.d0af52eb.jpg";